import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0a716e',
    },
    secondary: {
      main: '#ededed',
    },
    background: {
      default: '#fff',
    },
  },
  typography: {
    fontFamily: [
      'Neue Haas Grotesk Display Pro',
      'Inter',
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  shape: {
    borderRadius: 12,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        // Base style for all buttons
        root: {
          textTransform: 'none',          // keep normal case
          fontWeight: 500,
          borderRadius: 30,
          fontFamily: 'Neue Haas Grotesk Display Pro'
        },

        // Primary “contained” CTA
        containedPrimary: {
          backgroundColor: '#0a716e',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#075452',   // 10 % darker for hover
          },
        },

        // Secondary “outlined” button
        outlinedSecondary: {
          borderColor: '#0a716e',
          color: '#0a716e',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'rgba(10,113,110,0.08)', // subtle teal tint
            borderColor: '#0a716e',
          },
        },

        // Optional neutral text button (e.g., “Learn more”)
        text: {
          color: '#555',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
          },
        },
      },
    },
  },
});

export default theme;
